/**
 * @file        src/pages/hotel/CorporateDiscountList.jsx
 * @description Corporate Hotel → Discount List. Same list/form as the B2C Hotel
 *              Discount List (DiscountList.jsx), fixed to audience=b2b, instead
 *              of forking the page.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (Corporate Hotel menu parity with B2C).
 */
import DiscountList from './DiscountList';

export default function CorporateDiscountList() {
  return (
    <DiscountList
      title="Corporate Discount List"
      subtitle="Corporate Hotel · B2B discounts"
      audience="b2b"
    />
  );
}
